import { NolimitApplication } from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import { Device } from "@nolimitcity/slot-launcher/bin/interfaces/APIOptions";
import { ScreenBounds } from "@nolimitcity/slot-launcher/bin/display/ScreenBounds";

/**
 * Created by Sebastian on 22/07/2019.
 */

export interface IResizeData {
    top: number;
    bottom: number;
    left: number;
    right: number;
    width: number;
    height: number;
    orientation: string;
    isLeftHanded?: boolean;
}

export interface IDimOrientation {
    readonly landscape:IDimData;
    readonly portrait:IDimData;
}

export interface IDimData{
    readonly scale:PIXI.Point;
    readonly position:PIXI.Point;
    readonly rotation?:number;
}

export interface LayoutDimData {
    position:PIXI.Point;
    scale:PIXI.Point;
    rotation?:number;
}

export class ResizeHelper {

    private constructor(){  }
    
    public static get resizeData():ScreenBounds{ return NolimitApplication.screenBounds }

    public static calcDim(dim:IDimOrientation):LayoutDimData{
        let oriDim:IDimData = this.isLandscape ? dim.landscape : dim.portrait;
        
        return {
            rotation:       oriDim.rotation != undefined ? oriDim.rotation : 0,
            scale:          oriDim.scale,
            position:       oriDim.position
        };
    }

    public static setDimForTarget(target:PIXI.DisplayObject,dim:IDimOrientation):void{
        const oriDim:LayoutDimData = this.calcDim(dim);
        target.scale = oriDim.scale;
        target.position = oriDim.position;
    }

    public static get isLandscape():boolean{
        return NolimitApplication.isLandscape;
    }

    public static get isMobile():boolean{
        return NolimitApplication.apiPlugin.options.device === Device.MOBILE;
    }
    
    // Have to be another way to figure out if it's an Ipad. Feel free to change it if you have an solution.
    public static get isIPadd():boolean{
        if(this.isLandscape)
            return (ResizeHelper.resizeData.width >= 955 && ResizeHelper.resizeData.width <= 965);
        else
            return (ResizeHelper.resizeData.height >= 955 && ResizeHelper.resizeData.height <= 965);
    }
}